import { DateTime } from "luxon";
import { ReactNode, useEffect, useState } from "react";
import { useLogout } from "../hooks/logout.hook";
import { debugModeActive, isNotInMobileApp } from "../lib/utils";
import { LogOut } from "lucide-react";

export interface PageTitleProps {
    children: ReactNode
}

export function PageTitle(props: PageTitleProps) {
    const [currentUTCTime, setCurrentUTCTIme] = useState<DateTime>(DateTime.utc())
    const logout = useLogout()

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentUTCTIme(DateTime.utc())
        }, 1000)

        return () => {
            clearInterval(timer)
        }
    }, [])

    return (
        <div className="flex items-start gap-4">
            <div className="flex items-start gap-2">
                {props.children}
            </div>
            {isNotInMobileApp() &&
                <button type="button" onClick={logout} title="Logout now" className="cursor-pointer">
                    <LogOut className="text-3xl text-gray-800 justify-center" size={32} />
                </button>
            }
            {debugModeActive() &&
                <div>{currentUTCTime.toFormat("dd-MM-yyyy HH:mm:ss")} UTC</div>
            }
        </div>
    )
}